import { render } from "./TelehealthNotificationItem.vue?vue&type=template&id=5a5fb094&scoped=true&ts=true"
import script from "./TelehealthNotificationItem.vue?vue&type=script&lang=ts"
export * from "./TelehealthNotificationItem.vue?vue&type=script&lang=ts"

import "./TelehealthNotificationItem.vue?vue&type=style&index=0&id=5a5fb094&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5fb094"]])

export default __exports__